// React Imports
import { ReactElement } from "react";

// Local Imports
import CollapseComponent from "../../../../components/collapse.component";
import ReactCountryFlag from "react-country-flag";
import { Divider } from "antd";

interface FatcaProps {
  [key: string]: any;
}

const FatcaAndCrs: React.FC<FatcaProps> = ({
  accountKycDetails,
}: FatcaProps): ReactElement => {
  return (
    <section className="flex flex-col w-full h-full">
      <div className="flex flex-col p-[10px]">
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">FATCA</h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[32%] flex flex-col">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                US person
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.isUsPerson ? "Yes" : "No"}
              </span>
            </div>
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Tax identification number (TIN)
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.tin || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Country
                </p>
                <div className="flex items-center gap-2">
                  <ReactCountryFlag
                    style={{
                      fontSize: "24px",
                    }}
                    countryCode={
                      accountKycDetails?.accountInfo[0]?.fatcaCountry
                        ?.countryCode
                    }
                    svg
                  />
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.fatcaCountry?.nameEn ||
                      "-"}
                  </span>
                </div>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Building
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaBuilding || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Street
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaStreet || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Avenue
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaAvenue || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Block
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaBlock || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  P.O.Box
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaPobox || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Postal code
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaZipCode || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.isUsPerson && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Telephone number outside Kuwait
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fatcaTelephone || "-"}
                </span>
              </div>
            )}
          </div>
        </CollapseComponent>
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">CRS</h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[32%] flex flex-col">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Do you pay taxes in countries other than the U.S?
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.crs1TaxCountryId
                  ? "Yes"
                  : "No"}
              </span>
            </div>
            {accountKycDetails?.accountInfo[0]?.crs1TaxCountryId && (
              <div className="w-full">
                <h4 className=" font-semibold">CRS #1</h4>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs1TaxCountryId && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Country
                </p>
                <div className="flex items-center gap-2">
                  <ReactCountryFlag
                    style={{
                      fontSize: "24px",
                    }}
                    countryCode={
                      accountKycDetails?.accountInfo[0]?.crs1TaxCountry
                        ?.countryCode
                    }
                    svg
                  />
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs1TaxCountry
                      ?.nameEn || "-"}
                  </span>
                </div>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs1TaxCountryId && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Do you have tax identification number?
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.crs1TinExists
                    ? "Yes"
                    : "No"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs1TinExists && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Tax identification number (TIN)
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.crs1Tin || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs1TaxCountryId &&
              !accountKycDetails?.accountInfo[0]?.crs1TinExists && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Reason for not having a TIN
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs1NoTinReason
                      ?.description || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.crs1TaxCountryId &&
              !accountKycDetails?.accountInfo[0]?.crs1TinExists && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Why you are unable to obtain a TIN?
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs1ReasonDescription ||
                      "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.crs2TaxCountryId && <Divider />}
            {accountKycDetails?.accountInfo[0]?.crs2TaxCountryId && (
              <div className="w-full">
                <h4 className=" font-semibold">CRS #2</h4>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs2TaxCountryId && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Country
                </p>
                <div className="flex items-center gap-2">
                  <ReactCountryFlag
                    style={{
                      fontSize: "24px",
                    }}
                    countryCode={
                      accountKycDetails?.accountInfo[0]?.crs2TaxCountry
                        ?.countryCode
                    }
                    svg
                  />
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs2TaxCountry
                      ?.nameEn || "-"}
                  </span>
                </div>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs2TaxCountryId && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Do you have tax identification number?
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.crs2TinExists
                    ? "Yes"
                    : "No"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs2TinExists && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Tax identification number (TIN)
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.crs2Tin || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs2TaxCountryId &&
              !accountKycDetails?.accountInfo[0]?.crs2TinExists && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Reason for not having a TIN
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs2NoTinReason
                      ?.description || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.crs2TaxCountryId &&
              !accountKycDetails?.accountInfo[0]?.crs2TinExists && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Why you are unable to obtain a TIN?
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs2ReasonDescription ||
                      "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.crs3TaxCountryId && <Divider />}
            {accountKycDetails?.accountInfo[0]?.crs3TaxCountryId && (
              <div className="w-full">
                <h4 className=" font-semibold">CRS #3</h4>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs3TaxCountryId && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Country
                </p>
                <div className="flex items-center gap-2">
                  <ReactCountryFlag
                    style={{
                      fontSize: "24px",
                    }}
                    countryCode={
                      accountKycDetails?.accountInfo[0]?.crs3TaxCountry
                        ?.countryCode
                    }
                    svg
                  />
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs3TaxCountry
                      ?.nameEn || "-"}
                  </span>
                </div>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs3TaxCountryId && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Do you have tax identification number?
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.crs3TinExists
                    ? "Yes"
                    : "No"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs3TinExists && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Tax identification number (TIN)
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.crs3Tin || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.accountInfo[0]?.crs3TaxCountryId &&
              !accountKycDetails?.accountInfo[0]?.crs3TinExists && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Reason for not having a TIN
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs3NoTinReason
                      ?.description || "-"}
                  </span>
                </div>
              )}
            {accountKycDetails?.accountInfo[0]?.crs3TaxCountryId &&
              !accountKycDetails?.accountInfo[0]?.crs3TinExists && (
                <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                  <p className=" text-black-300 text-xs font-normal mb-[10px]">
                    Why you are unable to obtain a TIN?
                  </p>
                  <span className=" text-base font-semibold text-lightGray-200">
                    {accountKycDetails?.accountInfo[0]?.crs3ReasonDescription ||
                      "-"}
                  </span>
                </div>
              )}
          </div>
        </CollapseComponent>
      </div>
    </section>
  );
};

export default FatcaAndCrs;
